<template>
  <ListeReferentiel
    ref="liste"
    titre="Types de consultation"
    icone="bi-file-medical"
    ressource="type_consultations"
    tri-defaut="tc.nom"
    :options-tri="{ Nom: 'tc.nom', Prix: 'tc.prix', Statut: 'tc.isEnabled' }"
    placeholder="Nom ou description…"
    unite="type(s)"
    vide="Aucun type de consultation enregistré."
    :colonnes="6"
    :peut-creer="peutCreer"
    libelle-creer="Nouveau type"
    @creer="creation"
  >
    <template #boutons>
      <button class="btn btn-outline-primary shadow-sm" :disabled="impression" @click="imprimerTypesConsultations">
        <i class="bi bi-printer me-1"></i>Imprimer
      </button>
    </template>
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-sm-table-cell">Prix</th>
      <th class="d-none d-md-table-cell">Description</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.nom }}</td>
      <td class="d-none d-sm-table-cell">{{ fcfa(type.prix) }}</td>
      <td class="d-none d-md-table-cell">{{ type.description || '—' }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="peutModifier || peutSupprimer" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="peutModifier"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="peutModifier"><a class="dropdown-item" href="#" @click.prevent="changerStatus(type)">{{ type.isEnabled ? 'Désactiver' : 'Activer' }}</a></li>
            <li v-if="peutSupprimer"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api, { messageErreur, notifier } from '@/api';
import { imprimer, e, fcfa } from '@/impression/impression';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeTypeConsultation',
  components: { ListeReferentiel },
  data() {
    return { impression: false };
  },
  computed: {
    peutCreer() { return this.$store.getters.hasPermission('CONFIG_CREER_TYPE_CONSULTATION'); },
    peutModifier() { return this.$store.getters.hasPermission('CONFIG_MODIFIER_TYPE_CONSULTATION'); },
    peutSupprimer() { return this.$store.getters.hasPermission('CONFIG_SUPPRESSION_TYPE_CONSULTATION'); },
  },
  methods: {
    fcfa(v) {
      return v !== null && v !== undefined && v !== '' ? fcfa(v) : '—';
    },
    creation() {
      this.$router.push({ name: 'create_type_consultation' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_consultation', params: { id } });
    },
    async changerStatus(type) {
      try {
        await api.updateItem('type_consultations', type.id, { isEnabled: !type.isEnabled });
        notifier(type.isEnabled ? 'Type de consultation désactivé.' : 'Type de consultation activé.', 'success');
        this.$refs.liste.charger();
      } catch (error) {
        // 403 : déjà signalé par l'intercepteur axios
        if (error?.response?.status !== 403) notifier(messageErreur(error, "Le statut n'a pas pu être changé."), 'danger');
      }
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: 'Supprimer le type de consultation',
        message: `Supprimer le type de consultation « ${type.nom} » ?`,
        succes: 'Type de consultation supprimé.',
      });
    },
    /** Imprime tous les types qui correspondent à la recherche et au statut choisis (100 au plus). */
    async imprimerTypesConsultations() {
      const liste = this.$refs.liste;
      this.impression = true;
      let types = [];
      try {
        const res = await api.liste('type_consultations', {
          page: 1, itemsperpage: 100, search: liste.recherche.trim(), actif: liste.actif, orderBy: liste.tri, sortOrder: liste.sens,
        });
        types = res.data?.data || [];
      } catch (err) {
        notifier(messageErreur(err, "La liste à imprimer n'a pas pu être chargée."), 'danger');
        return;
      } finally {
        this.impression = false;
      }
      if (!types.length) {
        notifier('Aucun type de consultation à imprimer.', 'danger');
        return;
      }
      const infos = [`${types.length} type${types.length > 1 ? 's' : ''} de consultation`];
      if (liste.recherche.trim()) infos.push(`Recherche : « ${liste.recherche.trim()} »`);
      const lignes = types.map((t, i) => `
        <tr${t.isEnabled ? '' : ' class="muted"'}>
          <td class="centre">${i + 1}</td>
          <td><strong>${e(t.nom || '')}</strong></td>
          <td class="droite">${t.prix !== null && t.prix !== undefined && t.prix !== '' ? e(fcfa(t.prix)) : '—'}</td>
          <td>${e(t.description || '—')}</td>
          <td class="centre"><span class="${t.isEnabled ? 'badge-ok' : 'badge-ko'}">${t.isEnabled ? 'Activé' : 'Désactivé'}</span></td>
        </tr>`).join('');
      const corps = `
        <table class="lignes">
          <thead><tr>
            <th style="width:28px">#</th><th>Nom</th><th class="droite">Prix</th><th>Description</th><th class="centre">Statut</th>
          </tr></thead>
          <tbody>${lignes}</tbody>
        </table>`;
      await imprimer({
        titre: 'Types de consultations',
        sousTitre: infos.join(' · '),
        corps,
      });
    },
  },
};
</script>
